import { useQuery } from "@tanstack/react-query";
import { useApi } from "@/core/api";
import type { ForwardingCheck } from "@/onboarding/simple-onboarding/types";
import { AP_STALE_TIME } from "./polling";

interface ApForwarding {
  has_processed_invoices: boolean;
  ap_inbound_email: string | null;
  forwarding_check: ForwardingCheck;
}

export const useApForwarding = (businessId: string | null) => {
  const api = useApi();
  return useQuery({
    queryKey: ["ap-forwarding", businessId],
    queryFn: ({ signal }) =>
      api
        .get<ApForwarding>(`/businesses/${businessId}/ap/forwarding`, {
          signal,
        })
        .then(({ data }) => data),
    enabled: Boolean(businessId),
    staleTime: AP_STALE_TIME,
    refetchOnMount: "always",
    refetchInterval: ({ state }) =>
      state.data?.has_processed_invoices ? false : 5_000,
  });
};
